import LBox from "@components/LBox";
import LText from "@components/LText";

/** In place of the price and the way to buy, once the event is cancelled. */
const Cancelled = () => {
  return (
    <LBox
      padding="s4"
      borderRadius="m-l"
      backgroundColor="whiteTranslucent10"
      gap="s2"
    >
      <LText variant="Heading/H2/Medium" color="white">
        Cancelled
      </LText>
      <LText variant="Body/B2/Regular" color="whiteTranslucent70">
        This event has been cancelled. If you bought a ticket, check your email
        for your refund.
      </LText>
    </LBox>
  );
};

export default Cancelled;
